import { getFontFullPath } from '@/Pages/Clip/SideBar/FontSelector/constants';
import { CaptionLineConfig, CaptionStyles } from '@/domains/asset';
import { TransitionInEffect } from '@/App/remotion/libs/transitions/types';

const corporate: Partial<CaptionStyles> = {
  theme_preset: 'corporate',
  pageStyle: {
    color: '#ffffff',
    background: '#000000a6',
    borderRadius: '16px',
    paddingLeft: '16px',
    paddingRight: '16px'
  },
  wordStyle: undefined,
  letterStyle: undefined,
  font_location: getFontFullPath('Inter-Medium.ttf'),
  caps: false,
  line_config: CaptionLineConfig.OneLine,
  font_size: 64,
  transitions: {
    pageIn: TransitionInEffect.None
  }
};

export default corporate;
